export default {
  driverListItem: {
    borderRadius: '5px',
    justifyContent: 'center',
    alignItems: 'center'
  }
};
